import React, { useEffect, useState } from "react";
import Button from "../shared/Button"; // Import the custom Button component
import "./Navbar.scss";
import logo from "../../assets/mentorsity-logo.png";
import { Link } from "react-router-dom";
import ExplorePrograms from "../explorePrograms/ExplorePrograms";
import { IoIosArrowDown } from "react-icons/io";
import { FaUser } from "react-icons/fa";
import { FaBars, FaTimes } from "react-icons/fa";
import MobileExplorePrograms from "../explorePrograms/mobileExplorePrograms";
import LoginModal from "./LoginModal";
import SignupModal from "./SignupModal";
import EventsBanner from "./EventsBanner";


// import ExploreProgram

export default function Navbar() {
    // const [isDropdownOpen, setDropdownOpen] = useState(false);
    const [isExploreProgramOpenForLg, setIsExploreProgramOpenForLg] = useState(false);
    const [isMobileMenuOpen, setMobileMenuOpen] = useState(false); // State for mobile menu
    const [isExploreProgramOpen, setIsExploreProgram] = useState(false); // State for mobile menu
    const [selectedLink, setSelectedLink] = useState('/');
    const [isLoginOpen, setIsLoginOpen] = useState(false);
    const [isSignupOpen, setIsSignupOpen] = useState(false);

    const toggleMobileMenu = () => {
        setMobileMenuOpen(!isMobileMenuOpen);
        setTimeout(setIsExploreProgram(false), 1000);
    };
    const toggleExploreProgram = () => {
        setIsExploreProgram(!isExploreProgramOpen);
    };

    const toggleExploreProgramForLg = () => {
        setIsExploreProgramOpenForLg(!isExploreProgramOpenForLg)
    }

    useEffect(() => {
        if (isExploreProgramOpen || isExploreProgramOpenForLg) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = '';
        }

        return () => {
            document.body.style.overflow = '';
        };
    }, [isExploreProgramOpen, isExploreProgramOpenForLg]);

    return (
        <>
            <div className="flex flex-col">
                <EventsBanner />
                <div>
                    <div className="w-full flex items-center bg-white shadow-md sticky top-0 z-40">
                        <div className="w-full mx-auto flex flex-col justify-center items-center">
                            <div className="w-full max-w-[1200px] mx-auto flex flex-row items-center py-3 z-40 justify-between px-4 sm:px-6 lg:px-8">

                                {/* Logo and Mobile Menu Button */}
                                <div className="flex items-center">
                                    <button
                                        className="text-gray-800 lg:hidden focus:outline-none mr-3"
                                        onClick={toggleMobileMenu}
                                    >
                                        {isMobileMenuOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
                                    </button>
                                    <a href="/" className="text-xl font-medium">
                                        <img src={logo} alt="logo" width="140" height="45" />
                                    </a>
                                </div>

                                {/* Mobile Programs Button */}
                                <div className={`max-[830px]:block hidden explore-button hover:border-[#c9dbff73] ${isExploreProgramOpen ? "!border-[#c9dbff73]" : ""}`}>
                                    <button
                                        className={`py-2 px-4 rounded-md hover:bg-[#c9dbff73] transition-all text-sm ${isExploreProgramOpen ? "bg-[#c9dbff73] text-primary-color" : "text-secondaryColor"} text-left w-full`}
                                        onClick={toggleExploreProgram}
                                        style={{ textAlign: 'left' }}
                                    >
                                        Programs
                                    </button>
                                </div>

                                {/* Nav Links */}
                                <div className="hidden min-[831px]:flex items-center">
                                    <ul className="hidden min-[831px]:flex space-x-8">
                                        <li>
                                            <Link
                                                to="/"
                                                onClick={() => setSelectedLink('/')}
                                                className={`text-gray-800 ${selectedLink === '/' ? 'selectedNavbarMenu' : 'hoverNavbarMenu'}`}
                                            >
                                                Home
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="/about-us"
                                                onClick={() => setSelectedLink('/about-us')}
                                                className={`text-gray-800 ${selectedLink === '/about-us' ? 'selectedNavbarMenu' : 'hoverNavbarMenu'}`}
                                            >
                                                About
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="/successStories"
                                                onClick={() => setSelectedLink('/successStories')}
                                                className={`text-gray-800 ${selectedLink === '/successStories' ? 'selectedNavbarMenu' : 'hoverNavbarMenu'}`}
                                            >
                                                Success Stories
                                            </Link>
                                        </li>
                                        <li>
                                            <Link
                                                to="/blogs"
                                                onClick={() => setSelectedLink('/blogs')}
                                                className={`text-gray-800 ${selectedLink === '/blogs' ? 'selectedNavbarMenu' : 'hoverNavbarMenu'}`}
                                            >
                                                Blogs
                                            </Link>
                                        </li>
                                    </ul>
                                </div>

                                {/* Right Side - CTA Buttons */}
                                <div className="hidden min-[831px]:flex items-center space-x-4">
                                    {/* Explore Programs dropdown */}
                                    <div className="hidden min-[831px]:block relative">
                                        <div 
                                            className={`text-sm font-semibold py-2 px-4 border border-primary-color rounded-md cursor-pointer flex flex-row justify-center items-center space-x-1 text-primary-color hover:bg-[#c9dbff73] transition-all ${isExploreProgramOpenForLg ? "bg-[#c9dbff73]" : ""}`} 
                                            onClick={toggleExploreProgramForLg}
                                        >
                                            <span>Explore programs</span>
                                            <IoIosArrowDown className={`text-[12px] ${isExploreProgramOpenForLg ? "-rotate-180" : ""} transition duration-150`} />
                                        </div>
                                    </div>

                                    {/* Login and Signup Buttons */}
                                    <div className="hidden min-[831px]:flex space-x-2">
                                        <Button
                                            text="Login"
                                            onClick={() => setIsLoginOpen(true)}
                                            config={{
                                                type: "secondary",

                                                width: "w-[85px]",
                                                fontSize: "text-sm",
                                                padding: "py-2"
                                            }}
                                        />
                                        <Button
                                            text="Signup"
                                            onClick={() => setIsSignupOpen(true)}
                                            config={{
                                                type: "primary",

                                                width: "w-[85px]",
                                                fontSize: "text-sm",
                                                padding: "py-2"
                                            }}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Backdrop blur when dropdown is open */}
                    {isExploreProgramOpenForLg && (

                          <div className="fixed inset-0 bg-black/30 backdrop-blur-sm z-30" style={{ top: '70px' }}></div>

                    )}

                    {/* Mobile Menu (collapsed) */}
                    <div className={`mobile-menu-overlay ${isMobileMenuOpen ? "open" : ""}`} onClick={toggleMobileMenu}></div>

                    {/* Mobile Menu Sidebar */}
                    <div className={`mobile-menu ${isMobileMenuOpen ? "open" : ""}`}>
                        <div className="w-full flex items-center bg-white shadow-md sticky top-0 z-50">
                            <div className="w-full mx-auto flex flex-col justify-center items-center">
                                <div className="w-[90%] flex flex-row items-center py-4 z-40 justify-between">
                                    {/* Logo */}
                                    <div className="flex justify-center items-center">
                                        <button
                                            className="text-gray-800 focus:outline-none"
                                            onClick={toggleMobileMenu}
                                        >
                                            <FaTimes size={22} />
                                        </button>
                                    </div>
                                    <div className="w-full flex justify-center ">
                                        <a href="/" className="text-xl font-medium flex justify-center items-center">
                                            <img src={logo} alt="logo" width="140" height="45" />
                                        </a>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="w-[90%] m-auto mobile-menu-cont">
                            <div className="w-full bg-white p-4 rounded-lg shadow-md mt-6 flex justify-between items-center">
                                {/* User Info */}
                                <div className="flex items-center space-x-3">
                                    <span className="user-icon bg-gray-300 p-2 rounded-full">
                                        <FaUser className="text-gray-800 text-xl" />
                                    </span>
                                    <div className="flex flex-col items-start">
                                        <span className="text-gray-800 font-bold text-base">Hello, Guest</span>
                                        <span className="text-sm text-[#848383] hover:text-primaryColor cursor-pointer">
                                            <a href="/career-guidance">Get Career Guidance</a>
                                        </span>
                                    </div>
                                </div>

                                {/* Login Button */}
                                <div className="flex items-center">
                                    <button
                                        className="text-white font-semibold px-5 py-2 rounded bg-[#04236B] hover:bg-blue-900 focus:outline-none transition-all duration-300"
                                        onClick={() => setIsLoginOpen(true)}
                                    >
                                        Login
                                    </button>
                                </div>
                            </div>

                            {/* Menu Links */}
                            <ul className="flex flex-col space-y-1 my-6">
                                <li>
                                    <Link to="/" className="menu-item" onClick={toggleMobileMenu}>Home</Link>
                                </li>
                                <li>
                                    <Link to="/about-us" className="menu-item" onClick={toggleMobileMenu}>About</Link>
                                </li>
                                <li>
                                    <Link to="/successStories" className="menu-item" onClick={toggleMobileMenu}>Success Stories</Link>
                                </li>
                                <li>
                                    <Link to="/blogs" className="menu-item" onClick={toggleMobileMenu}>Blogs</Link>
                                </li>
                            </ul>

                            {/* Signup Button */}
                            <div className="w-full flex justify-center mt-4">
                                <Button
                                    text="Signup"
                                    onClick={() => setIsSignupOpen(true)}
                                    config={{
                                        type: "primary",
                                        width: "100%",
                                        borderRadius: "5px",
                                        backgroundColor: "#ffffff",
                                        border: "2px solid #04236B",
                                        color: "#04236B",
                                    }}
                                />
                            </div>
                        </div>
                    </div>

                    <div className={`explore-program-overlay ${isExploreProgramOpen ? "open" : ""}`} onClick={toggleExploreProgram}></div>

                    {/* Mobile Explore Programs Dropdown (top to bottom, show for <=830px, left aligned) */}
                    <div className={`explore-program-mobile-dropdown ${isExploreProgramOpen ? "open" : ""} fixed top-[60px] left-0 w-full z-50 transition-all duration-300 bg-white shadow-lg max-h-[90vh] overflow-y-auto max-[830px]:block hidden text-left items-start`}>
                        {isExploreProgramOpen && (
                            <MobileExplorePrograms toggleClose={toggleExploreProgram} />
                        )}
                    </div>

                    {isLoginOpen && <LoginModal toggleClose={setIsLoginOpen} />}
                    {isSignupOpen && <SignupModal toggleClose={setIsSignupOpen} />}
                </div>
                <div className="hidden min-[831px]:flex relative">
                    {isExploreProgramOpenForLg ? <ExplorePrograms /> : <></>}
                </div>
            </div>
        </>
    );
}
